<template>
  <div class="random">
    <div class="head">随机抽奖</div>

    <div class="input">
      序号
      <input class="input__item" type="number" v-model="startNumber" placeholder="请输入大约于等于 1 的整数">
      -
      <input class="input__item" type="number" v-model="endNumber" placeholder="请输入大约于等于 1 的整数">
    </div>

    <div class="input">
      数量
      <input class="input__item" type="number" v-model="needNumber" placeholder="请输入大约于等于 1 的整数">
    </div>

    <van-button
      class="btn"
      type="primary"
      size="large"
      @click="createRandomNumber"
    >随机</van-button>

    <div v-if="result" class="result">
      <div class="result__item" v-for="item in result" :key="item">{{ item }}</div>
    </div>

    <copyright></copyright>
  </div>
</template>

<script>
import Copyright from '@/components/Copyright'
import { Button, Popup } from 'vant'
import api from '@/api'
import shuffle from 'lodash/shuffle'

export default {
  name: 'Random',
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    'copyright': Copyright,
  },
  data () {
    return {
      startNumber: 3,
      endNumber: 29,
      needNumber: 3,
      result: null,
      resultShow: false
    }
  },
  methods: {
    showPopup() {
      this.resultShow = true
    },
    createRandomNumber() {
      const start = Number(this.startNumber)
      const end = Number(this.endNumber)
      const num = Number(this.needNumber)
      let list = []
      if (start && end && num) {
        for (let i = start; i <= end; i++) {
          list.push(i)
        }

        list = shuffle(list)
        console.log(list)

        const res = list.splice(0, num)
        console.log(res)
        this.result = res
      } else {
        this.$toast('请完善信息')
        this.result = null
      }
    }
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
.random {
  max-width: 540PX;
  margin: 0 auto;
  padding: 0 20px;
  .head {
    padding-top: 20px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .input {
    margin-top: 20px;
    font-size: 20px;
    &__item {
      margin: 0 10px;
      width: 100px;
      height: 40px;
      border: 1px solid #ccc;
      text-align: center;
      background: none;
    }
  }
  .btn {
    margin-top: 20px;
  }
  .result {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    &__item {
      flex-shrink: 0;
      margin: 0 10px 10px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      font-size: 20px;
      font-weight: bold;
      line-height: 40px;
      text-align: center;
      color: #000;
      background-color: #ccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/random/index.vue